import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { paths } from '../../generated/portal-api';

export function createBankAccountApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		changeIban(data: { currentIban: string; newIban: string }) {
			return client.POST('/api/iban-wijzigen', { body: { currentAccount: data.currentIban, newAccount: data.newIban } });
		},
	};
}
